import { useLocation } from 'react-router-dom';

export const useURIQuery = () => {
  return new URLSearchParams(useLocation().search);
};
